import React from 'react';
import { motion } from 'framer-motion';
import { Store, ArrowRight } from 'lucide-react';
export function MerceriaPostPurchase() {
  return;
}